<template>

	<b-navbar
		v-if="isAuthenticated && userInfo"
		toggleable="md"
		type="dark"
		variant="secondary"

	>
		<b-navbar-nav>

			<b-nav-item :to="{ name: 'clocks' }">Clocks</b-nav-item>

			<b-nav-item :to="{ name: 'contracts' }">Service Contracts</b-nav-item>

			<b-nav-item :to="{ name: 'customers' }">Customers</b-nav-item>

			<b-nav-item :to="{ name: 'jobs' }">Jobs</b-nav-item>

			<b-nav-item :to="{ name: 'routeplans' }">Route Plans</b-nav-item>

			<b-nav-item :to="{ name: 'users' }">Users</b-nav-item>

			<b-nav-item-dropdown
				text="More"
				toggle-class="nav-link-custom"
				right
			>
				<b-dropdown-item :to="{ name: 'contacts' }">Contacts</b-dropdown-item>
				<b-dropdown-item :to="{ name: 'settings' }">Settings</b-dropdown-item>

			</b-nav-item-dropdown>

			<b-nav-item @click.prevent="logoutClick">Log out</b-nav-item>

		</b-navbar-nav>
	</b-navbar>
</template>


<script>
import { mapState, mapActions, mapGetters } from "vuex";

export default {
	name: "SiteHeader",

	computed: {
		...mapGetters(["isAuthenticated", "userInfo"]),
	},

	methods: {
		...mapActions(["doLogout"]),

		logoutClick() {
			this.doLogout();
		},
	},

	watch: {
		isAuthenticated(state) {
			if (!state) {
				this.$router.push({
					path: "/login",
				});
			} else {
				if (this.$route.query.nextUrl != null) {
					this.$router.push({
						path: this.$route.query.nextUrl,
					});
				} else {
					this.$router.push({
						path: "/",
					});
				}
			}
		},
	},
};
</script>


// WEBPACK FOOTER //
// src/components/layout/header.vue